namespace RioERP.Orders {
    export interface OrderTeacherShareCalculationForm {
        OrderId: Serenity.LookupEditor;
        OrderProductsId: Serenity.LookupEditor;
        TeacherId: Serenity.LookupEditor;
        SharePercentage: Serenity.DecimalEditor;
        OrderProdutcsCost: Serenity.DecimalEditor;
        ShareAmount: Serenity.DecimalEditor;
        Qty: Serenity.IntegerEditor;
        SettelmentId: Serenity.IntegerEditor;
        ESettelementStatus: Serenity.EnumEditor;
        TotalShare: Serenity.DecimalEditor;
    }

    export class OrderTeacherShareCalculationForm extends Serenity.PrefixedContext {
        static formKey = 'Orders.OrderTeacherShareCalculation';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OrderTeacherShareCalculationForm.init)  {
                OrderTeacherShareCalculationForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.DecimalEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.EnumEditor;

                Q.initFormType(OrderTeacherShareCalculationForm, [
                    'OrderId', w0,
                    'OrderProductsId', w0,
                    'TeacherId', w0,
                    'SharePercentage', w1,
                    'OrderProdutcsCost', w1,
                    'ShareAmount', w1,
                    'Qty', w2,
                    'SettelmentId', w2,
                    'ESettelementStatus', w3,
                    'TotalShare', w1
                ]);
            }
        }
    }
}
